import {Button, DialogActions} from '@material-ui/core';
import {hideModal} from 'Core/ducks/modal';
import React from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router';
import Modal from 'Shared/components/Modal';
import {UserRouteConstants} from 'Users/Routes';

const LegacyAccessModal = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Modal onClose={() => dispatch(hideModal())} open title="Legacy Access Alert">
      <div className="alerts-modal">
        <div className="alerts-modal__alerts-list">You don't have a SSO account</div>
        <DialogActions>
          <Button
            onClick={() => {
              history.push(UserRouteConstants.ADD_SSO_ACCOUNT);
              dispatch(hideModal());
            }}
            variant="contained"
            color="primary"
          >
            Add New SSO Account
          </Button>
          <Button onClick={() => dispatch(hideModal())} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </div>
    </Modal>
  );
};

export default LegacyAccessModal;
